module.exports = __webpack_public_path__ + "static/media/Favorites_Icon_Active@3x.4ab2c846.png";